/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Box, Slider } from '@mui/material';
import { ControlProps } from '../ControlProps';

const marks = [
  {
    value: 20,
    label: 'A Sentence',
  },
  {
    value: 300,
    label: 'A Paragraph',
  },
  {
    value: 1000,
    label: 'Several Paragraphs',
  },
  {
    value: 2000,
    label: 'A Page',
  },
];

const ToneControl = ({
  value,
  onChange,
  disabled,
}:ControlProps) => (
  <Box
    sx={{
      paddingX: '60px',
      width: '100%',
    }}
  >
    <Slider
      min={10}
      max={2500}
      aria-label="Always visible"
      defaultValue={250}
      step={10}
      marks={marks}
      valueLabelDisplay="on"
      value={value}
      onChange={onChange}
      disabled={disabled}
    />
  </Box>
);

export default ToneControl;
